import React from 'react';
export function MingaIcon({
  size = 32
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-121">
      <rect width="64" height="64" rx="14" fill="#2563EB" data-id="element-122" />
      <path d="M16 38L28 24L40 38L52 24" stroke="white" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-123" />
      <path d="M22 48H42" stroke="white" strokeWidth="4.5" strokeLinecap="round" data-id="element-124" />
    </svg>;
}